import { intersection } from 'lodash';
import { Permission as CorePermission } from 'pe-core-frontend';
export const isSuperuser = (user) => !!user?.isSuperuser;
export var GlobalPermission;
(function (GlobalPermission) {
    GlobalPermission["LIST_PROGRAMS"] = "list_programs";
    GlobalPermission["CREATE_PROGRAM"] = "create_program";
    GlobalPermission["UPDATE_PROGRAM"] = "update_program";
    GlobalPermission["LIST_BENEFIT_PERIODS"] = "list_benefit_periods";
    GlobalPermission["CREATE_BENEFIT_PERIOD"] = "create_benefit_period";
    GlobalPermission["UPDATE_BENEFIT_PERIOD"] = "update_benefit_period";
    GlobalPermission["DELETE_BENEFT_PERIOD"] = "delete_benefit_period";
    GlobalPermission["READ_PAYMENT_REQUEST"] = "read_payment_request";
    GlobalPermission["PROCESS_CLAIMS"] = "process_claims";
    GlobalPermission["VIEW_CLAIMS"] = "view_claims";
    GlobalPermission["LIST_SCHOOLS"] = "list_schools";
    GlobalPermission["LIST_COUNTRIES"] = "list_countries";
    GlobalPermission["UPDATE_PAYMENT_REQUEST"] = "update_payment_request";
    GlobalPermission["APPROVE_PAYMENT_REQUEST"] = "approve_payment_request";
    GlobalPermission["APPROVE_PROGRAM_REQUEST"] = "approve_program_request";
    GlobalPermission["CREATE_ACCREDITATION"] = "create_accreditation";
    GlobalPermission["UPDATE_ACCREDITATION"] = "update_accreditation";
    GlobalPermission["CREATE_SCHOOL"] = "create_school";
    GlobalPermission["UPDATE_SCHOOL"] = "update_school";
    GlobalPermission["UPDATE_COUNTRY"] = "update_country";
    GlobalPermission["DELETE_SCHOOL"] = "delete_school";
})(GlobalPermission || (GlobalPermission = {}));
export const EMPLOYEE_PERMISSIONS = [
    GlobalPermission.LIST_PROGRAMS,
    GlobalPermission.CREATE_PROGRAM,
    GlobalPermission.UPDATE_PROGRAM,
];
export const CLAIMS_PROCESSOR_PERMISSIONS = [
    CorePermission.LIST_CLIENTS,
    CorePermission.READ_USER,
    CorePermission.READ_CLIENT,
    CorePermission.CREATE_PREFERENCE,
    CorePermission.READ_PREFERENCE,
    CorePermission.LIST_PREFERENCES,
    CorePermission.UPDATE_PREFERENCE,
    CorePermission.DELETE_PREFERENCE,
    GlobalPermission.READ_PAYMENT_REQUEST,
    GlobalPermission.LIST_SCHOOLS,
    GlobalPermission.LIST_COUNTRIES,
    GlobalPermission.UPDATE_PAYMENT_REQUEST,
    GlobalPermission.APPROVE_PAYMENT_REQUEST,
];
export const MEMBER_SUPPORT_PERMISSIONS = [
    CorePermission.LIST_CLIENTS,
    CorePermission.READ_USER,
    CorePermission.READ_CLIENT,
    CorePermission.READ_PREFERENCE,
    CorePermission.LIST_PREFERENCES,
    GlobalPermission.READ_PAYMENT_REQUEST,
    GlobalPermission.LIST_SCHOOLS,
    GlobalPermission.LIST_COUNTRIES,
];
export const filterByRoles = (item, userRoles) => !item.roles || intersection(userRoles, item.roles).length > 0;
